'use client';

import { c as _c } from "react/compiler-runtime";
import Lottie from 'lottie-react';
import { FC } from 'react';
import { getEndFrame } from '@/components/ServicesLobbyPage/ServicesLobbyCards/Card/utils';
import { LOTTIE_SPEED } from '@/components/ServicesLobbyPage/ServicesLobbyCards/const';
import { ServicesLobbyCardDto } from '@/components/ServicesLobbyPage/ServicesLobbyCards/types';
import { Typography } from '@/components/shared/Typography';
import StrapiRichContent from '@/components/StrapiRichContent';
import useLottieHandlers from '@/hooks/useLottieHandlers';
import css from './style.module.scss';
const Card: FC<ServicesLobbyCardDto> = t0 => {
  const $ = _c(24);
  const {
    lottie,
    title,
    description
  } = t0;
  const {
    lottieRef,
    setSpeedHandler
  } = useLottieHandlers();
  let t1;
  if ($[0] !== lottie || $[1] !== lottieRef) {
    t1 = () => {
      const instance = lottieRef.current;
      if (!instance) {
        return;
      }
      instance.stop();
      instance.setDirection(1);
      instance.goToAndStop(getEndFrame(instance, lottie), true);
    };
    $[0] = lottie;
    $[1] = lottieRef;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const goToEndFrame = t1;
  let t2;
  if ($[3] !== goToEndFrame || $[4] !== setSpeedHandler) {
    t2 = () => {
      setSpeedHandler(LOTTIE_SPEED);
      goToEndFrame();
    };
    $[3] = goToEndFrame;
    $[4] = setSpeedHandler;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleLottieLoaded = t2;
  let t3;
  if ($[6] !== lottieRef) {
    t3 = () => {
      const instance_0 = lottieRef.current;
      if (!instance_0) {
        return;
      }
      instance_0.stop();
      instance_0.setDirection(1);
      instance_0.goToAndStop(0, true);
      instance_0.play();
    };
    $[6] = lottieRef;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleMouseEnter = t3;
  let t4;
  if ($[8] !== goToEndFrame) {
    t4 = () => {
      goToEndFrame();
    };
    $[8] = goToEndFrame;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleMouseLeave = t4;
  let t5;
  if ($[10] !== handleLottieLoaded || $[11] !== lottie || $[12] !== lottieRef) {
    t5 = <Lottie aria-hidden={true} loop={false} autoplay={false} lottieRef={lottieRef} className={css.lottie} animationData={lottie} onDOMLoaded={handleLottieLoaded} />;
    $[10] = handleLottieLoaded;
    $[11] = lottie;
    $[12] = lottieRef;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== title) {
    t6 = <Typography uppercase={true} className={css.title} tag="h3" variant="h6"><StrapiRichContent content={title} /></Typography>;
    $[14] = title;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== description) {
    t7 = <Typography className={css.description} tag="div" variant="body-s"><StrapiRichContent content={description} /></Typography>;
    $[16] = description;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== handleMouseEnter || $[19] !== handleMouseLeave || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <article className={css.card} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>{t5}{t6}{t7}</article>;
    $[18] = handleMouseEnter;
    $[19] = handleMouseLeave;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
export default Card;